import { render, staticRenderFns } from "./ModalResumoTecnico.vue?vue&type=template&id=6b343d24&scoped=true&"
import script from "./ModalResumoTecnico.vue?vue&type=script&lang=js&"
export * from "./ModalResumoTecnico.vue?vue&type=script&lang=js&"
import style0 from "./ModalResumoTecnico.vue?vue&type=style&index=0&id=6b343d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b343d24",
  null
  
)

export default component.exports